var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-view"},[_c('HeaderView',{attrs:{"title":"登入"}}),_c('div',[_vm._v("uid:"+_vm._s(_vm.uid))]),_c('div',[_vm._v("acc:"+_vm._s(_vm.acc))]),_c('div',[_vm._v("nick:"+_vm._s(_vm.nick))]),_c('div',[_vm._v("from:"+_vm._s(_vm.from))]),_c('div',[_vm._v("url:"+_vm._s(_vm.url))]),_c('div',[_vm._v("icon:"+_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }